export const EARLY_ACCESS_MODAL_EVENT = "rugira:open-early-access";
export const EARLY_ACCESS_MODAL_HREF = "modal:early-access";

export function openEarlyAccessModal() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(EARLY_ACCESS_MODAL_EVENT));
}

export const scrollToEarlyAccess = openEarlyAccessModal;
